module.exports = __webpack_public_path__ + "img/logo-icon.27d35831.svg";